import React, { useState } from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { QuoteBlock } from '../../../ui/QuoteBlock/QuoteBlock.jsx'

/**
 * OneChangeCard — session-one-change (catalog #12, non-core).
 *
 * Single sentence ≤140 chars, serif quote display, surfaces as reminder
 * on next prep. QuoteBlock variant="olive".
 */

const SOFT_LIMIT = 140

export function OneChangeCard({ text = '', onChange, disabled = false }) {
  const [editing, setEditing] = useState(false)
  const hasContent = text.length > 0
  const isOver = text.length > SOFT_LIMIT

  function handleFocus() {
    if (!disabled) setEditing(true)
  }

  function handleBlur() {
    setEditing(false)
  }

  return (
    <CardFrame
      kind="session"
      icon="↗"
      iconClass="olive"
      title="One change"
      prompt="What's one thing you'll do differently?"
      state={disabled ? 'locked' : isOver ? 'error' : hasContent ? 'filled' : 'empty'}
      data-testid="session-card-one-change"
      className="session-card"
    >
      {hasContent && !editing ? (
        <QuoteBlock
          variant="olive"
          text={text}
          showQuotes={false}
          onClick={!disabled ? handleFocus : undefined}
          role={!disabled ? 'button' : undefined}
          tabIndex={!disabled ? 0 : undefined}
          aria-label={`One change: ${text}. Click to edit.`}
          onKeyDown={!disabled ? (e) => e.key === 'Enter' && handleFocus() : undefined}
        />
      ) : (
        <textarea
          className="session-card__textarea session-card__textarea--centered"
          value={text}
          maxLength={SOFT_LIMIT + 20}
          disabled={disabled}
          placeholder="One thing you'll do differently next time…"
          onChange={(e) => onChange?.(e.target.value)}
          onFocus={handleFocus}
          onBlur={handleBlur}
          aria-label="One change"
          rows={3}
        />
      )}
      {!disabled && (
        <div
          className="session-card__char-counter"
          style={{
            color: isOver ? 'var(--color-rust-600, #c0392b)' : 'var(--color-text-faint, #999)',
          }}
          aria-live="polite"
          aria-label={`${text.length} of ${SOFT_LIMIT} characters`}
        >
          {text.length}/{SOFT_LIMIT}
        </div>
      )}
    </CardFrame>
  )
}
